import styled from 'styled-components'

export const Image = styled.img`
  display: block;
  height: auto;
  width: 100%;
`
